<template>
  <div>
    <v-card class="organization-purchase">
      <h1>
        Publications Purchased by Organizations
      </h1>
      <v-divider></v-divider>
      <v-stepper v-model="purchaseStep">
        <v-stepper-header>
          <v-stepper-step editable step="1">
            Purchased Publications Dashbaord
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="2">
            Purchased Publication Assignment
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="3">
            Review Purchased Publication
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="4">
            Confirm Purchased Publication
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="publication-purchase" flat>
              <!-- <h1></h1>
              <v-divider></v-divider> -->
              <div class="row mb-5">
                <div class="col">
                  <div class="">
                    <v-text-field
                    id="paging_purchasedid"
                      v-model="paging_purchased.keyword"
                      label="Search"
                      required
                      append-outer-icon="mdi-table-search"
                      @click:append-outer="onSearch"
                      v-on:keyup.enter="onSearch()"
                    >
                    </v-text-field>
                  </div>
                </div>
                <div class="col d-flex align-center justify-end">
                  <div class="float-right">
                    <v-btn color="primary" class="" @click="newPurchase" id="btnNew"
                      >New</v-btn
                    >
                  </div>
                </div>
              </div>
              <v-data-table
                :headers="purpub_headers"
                :items="list"
                v-model="purchasePublication"
                hide-default-footer
              >
                <template v-slot:item.DateOfPayment="props">
                  <span>{{
                    props.item.DateOfPayment | DateFromatDDMMYYY
                  }}</span>
                </template>
                <template v-slot:item.id="props">
              <router-link
                :to="{
                  name: 'FulfillmentDetails',
                  params: {
                    id: props.item.id,
                    collection: props.item.IsCollection,
                    page: paging_purchased.page,
                    name: props.item.OrganizationName,
                    refno:props.item.ReferenceNo
                  }
                }"
              >
                <v-icon small color="blue darken-2">
                  mdi-domain
                </v-icon>
              </router-link>
            </template>
            <template v-slot:item.IsCancel="props">
               <span v-if="!props.item.IsCancel">
                    <v-icon small class="mr-2 icon-cancel" @click="onCancel(props.item)"
                      >mdi-cancel</v-icon>
                </span>
                <span v-if="props.item.IsCancel">Canceled</span>
            </template>

              </v-data-table>
              <v-row>
                <v-col cols="12">
                  <Pagination
                    :paging="paging_purchased"
                    v-on:next="onNextPagePurchased"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="publication-purchase" flat>
              <!-- <h1>Purchase Publication</h1>
              <v-divider></v-divider> -->
              <!--START Expension Panel -->
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Purchase Cart ( {{ cart_items.length }} )
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table
                      :headers="cart_headers"
                      :items="cart_items"
                      @item-selected="OnselectedPurchaseItem"
                      @input="handleInputSelection"
                      :item-class="row_invalidClass"
                      hide-default-footer
                      item-key="id"
                      class="elevation-1"
                    >
                      <template v-slot:item.PurchaseType="props">
                        <v-select
                          id="transactionType"
                          :items="purchaseTypeList"
                          label="Transaction type"
                          item-text="text"
                          item-value="value"
                          @change="onChangePurchaseType(props.item)"
                          v-model="props.item.PurchaseType"
                        ></v-select>
                      </template>
                      <template v-slot:item.NoOfCopies="props">
                        <v-text-field
                          v-model="props.item.NoOfCopies"
                          id="noOfCopies"
                          name="quantity"
                          outlined
                          @input="getdata"
                          type="number"
                          style="min-width:15px"
                        ></v-text-field>
                      </template>
                      <template v-slot:item.StartDate="props">
                        <div>
                          <v-menu
                            v-if="props.item.PurchaseType == 5"
                            id="purchaseType"
                            v-model="props.item.satrtDateAction"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                id="startDate"
                                v-model="props.item.StartDate"
                                prepend-icon="mdi-calendar"
                                label="Start date"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              id="startDate"
                              v-model="props.item.StartDate"
                              @input="props.item.satrtDateAction = false"
                              :max="props.item.EndDate"
                            ></v-date-picker>
                          </v-menu>
                          <div v-else>
                            {{ props.item.StartDate | DateFromatDDMMYYY }}
                          </div>
                        </div>
                      </template>
                      <template v-slot:item.EndDate="props">
                        <div>
                          <v-menu
                            v-if="props.item.PurchaseType == 5"
                            v-model="props.item.endDateAction"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                id="endDate"
                                v-model="props.item.EndDate"
                                prepend-icon="mdi-calendar"
                                label="End date"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              id="endatepicker"
                              v-model="props.item.EndDate"
                              @input="props.item.endDateAction = false"
                              :min="props.item.StartDate"
                            ></v-date-picker>
                          </v-menu>
                          <div v-else>
                            {{ props.item.EndDate | DateFromatDDMMYYY }}
                          </div>
                        </div>
                      </template>
                      <template v-slot:item.Id="props">
                        <div>
                          <v-btn
                            id="removeCartBtn"
                            icon
                            color="pink"
                            @click="removeFromCart(props.item)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!--END Expension Panel -->
              <Notification :notify="notify1" />
              <div class="row mb-5">
                <div class="col d-flex align-center">
                  <span class="mr-4 mt-4">Organization</span>
                  <v-select
                    id="organizationList"
                    class="organization-dropdown"
                    :items="organizationList"
                    label="Name"
                    item-text="Name"
                    item-value="id"
                    v-model="purchaseOrder.OrganizationId"
                  ></v-select>
                </div>
                <div class="col">
                  <div class="">
                    <v-text-field
                      id="avaliiableApplicationsSearch"
                      v-model="paging_avaliiableApplications.keyword"
                      label="Search"
                      required
                      append-outer-icon="mdi-table-search"
                      @click:append-outer="getAvalaibleApplicationsByPagin()"
                      v-on:keyup.enter="getAvalaibleApplicationsByPagin()"
                    >
                    </v-text-field>
                  </div>
                </div>
              </div>

              <v-data-table
                :headers="avaliablePublication_headers"
                :items="avaliiableApplicationList"
                @item-selected="OnselectedPurchaseItem"
                @input="handleInputSelection"
                hide-default-footer
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:item.PurchaseType="props">
                  <v-select
                    id="purchaseTypeList"
                    :items="purchaseTypeList"
                    label="Transaction type"
                    item-text="text"
                    item-value="value"
                    @change="onChangePurchaseType(props.item)"
                    v-model="props.item.PurchaseType"
                  ></v-select>
                </template>
                <template v-slot:item.NoOfCopies="props">
                  <v-text-field
                    id="noOfCopiesQuality"
                    v-model="props.item.NoOfCopies"
                    name="quantity"
                    outlined
                    @input="getdata"
                    :error="NoOfCopyError"
                    :error-messages="noOfCopyErrorMessage"
                    type="number"
                    full-width="true"
                  ></v-text-field>
                </template>
                <template v-slot:item.StartDate="props">
                  <div>
                    <v-menu
                      v-if="props.item.PurchaseType == 5"
                      v-model="props.item.satrtDateAction"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="StrtDate"
                          v-model="props.item.StartDate"
                          prepend-icon="mdi-calendar"
                          label="Start date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="props.item.StartDate"
                        :min="currentDate"
                        :max="props.item.EndDate"
                        @input="props.item.satrtDateAction = false"
                      ></v-date-picker>
                    </v-menu>
                    <div v-else>
                      {{ props.item.StartDate | DateFromatDDMMYYY }}
                    </div>
                  </div>
                </template>
                <template v-slot:item.EndDate="props">
                  <div>
                    <v-menu
                      v-if="props.item.PurchaseType == 5"
                      v-model="props.item.endDateAction"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="endDate"
                          v-model="props.item.EndDate"
                          prepend-icon="mdi-calendar"
                          label="End date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="props.item.EndDate"
                        :min="props.item.StartDate"
                        @input="props.item.endDateAction = false"
                      ></v-date-picker>
                    </v-menu>
                    <div v-else>
                      {{ props.item.EndDate | DateFromatDDMMYYY }}
                    </div>
                  </div>
                </template>
                <template v-slot:item.Id="props">
                  <div>
                    <v-btn
                      icon
                      :disabled="!isValidateRowItem(props.item)"
                      @click="addToCart(props.item)"
                    >
                      <v-icon>mdi-cart</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <v-row>
                <v-col cols="12">
                  <Pagination
                    :paging="paging_avaliiableApplications"
                    v-on:next="onNextAvaliiableApplications"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <Notification :notify="notify1" />
                </v-col>
              </v-row>
              <div class="row">
                <div class="col d-flex justify-end">
                  <div class="col d-flex justify-start">
                    <v-btn class="" @click="purchaseStep = 1">Back</v-btn>
                  </div>
                  <v-btn color="primary" class="" @click="navReviewPurchase()"
                    >Next</v-btn
                  >
                </div>
              </div>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="publication-purchase" flat height="100%">
              <!-- <h1>Review Purchase Publication</h1>
              <v-divider></v-divider> -->
              <div class="row mt-5 mb-5">
                <div class="col">
                  <div class="row">
                    <div class="col-4">
                      <p>Organization</p>
                      <p>No of Publications</p>
                      <p>No of Copies</p>
                    </div>
                    <div class="col-8">
                      <p>{{ comOrganizationName }}</p>
                      <p>{{ comNoOfPublications }}</p>
                      <p>{{ comNumberOfCcopies }}</p>
                    </div>
                  </div>
                </div>
                <!-- <div class="col">
                  <div class="row">
                    <div class="col-4">
                      <p>Min Start Date</p>
                      <p>Max Start Date</p>
                    </div>
                    <div class="col-8">
                      <p>{{ comMinStartDate }}</p>
                      <p>{{ comMaxEndDate }}</p>
                    </div>
                  </div>
                </div> -->
              </div>
              <v-data-table
                :headers="reviewPurchase_headers"
                :items="cart_items"
                hide-default-footer
              ></v-data-table>
              <v-row>
                <v-col cols="12"></v-col>
              </v-row>
              <div class="row">
                <v-btn class="" @click="purchaseStep = 2" id="btnPurcahseStep">Back</v-btn>
                <div class="col d-flex justify-end">
                  <v-btn color="primary" class="" @click="purchaseStep = 4" id="btnNext"
                    >Next</v-btn
                  >
                </div>
              </div>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="publication-purchase" flat height="100%">
              <!-- <h1>Confirm Purchase Publication</h1>
              <v-divider></v-divider> -->
              <Notification :notify="notify2" />
              <div class="row mt-5 mb-5">
                <div class="col">
                  <div class="row">
                    <div class="col-4">
                      <p>Organization</p>
                      <p>No of Publications</p>
                      <p>No of Copies</p>
                    </div>
                    <div class="col-8">
                      <p>{{ comOrganizationName }}</p>
                      <p>{{ comNoOfPublications }}</p>
                      <p>{{ comNumberOfCcopies }}</p>
                    </div>
                  </div>
                </div>
                <!-- <div class="col">
                  <div class="row">
                    <div class="col-4">
                      <p>Min Start Date</p>
                      <p>Max Start Date</p>
                    </div>
                    <div class="col-8">
                      <p>{{ comMinStartDate }}</p>
                      <p>{{ comMaxEndDate }}</p>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="row">
                <div class="col-6">
                  <div>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="purchaseOrder.DateOfPayment"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="DateOfPayment"
                          v-model="purchaseOrder.DateOfPayment"
                          label="Date of Payment"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="purchaseOrder.DateOfPayment"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(purchaseOrder.DateOfPayment)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <v-text-field-simplemask
                  id="ReferenceNo"
                v-model="purchaseOrder.ReferenceNo"
                v-bind:label="'Reference No'"
                v-bind:properties="{
                  prefix: '',
                  suffix: '',
                  readonly: false,
                  disabled: false,
                  outlined: false,
                  clearable: true,
                  placeholder: 'AA-1234'
                }"
                v-bind:options="{
                  inputMask: '##-#####',
                  outputMask: '##-#####',
                  empty: null,
                  applyAfter: false,
                  alphanumeric: true,
                  lowerCase: false
                }"
                v-bind:focus="focus"
                v-on:focus="focus = false"
              />
                  <v-text-field
                    id="PaymentMadeBy"
                    v-model="purchaseOrder.PaymentMadeBy"
                    label="Payment Made By"
                  ></v-text-field>
                  <v-text-field
                    id="Amount"
                    v-model="purchaseOrder.Amount"
                    label="Amount"
                  ></v-text-field>
                  <v-textarea
                    id="description"
                    label="Description"
                    v-model="purchaseOrder.Description"
                  ></v-textarea>
                </div>
              </div>
              <div class="row">
                <v-btn class="" @click="purchaseStep = 3">Back</v-btn>
                <div class="col d-flex justify-end">
                  <v-btn
                    id="purchaseOrderbtn"
                    @click="createPurchaseorder"
                    :disabled="purchaseCompleted"
                    color="primary"
                    class=""
                    >Confirm Purchase</v-btn
                  >
                </div>
              </div>
              <ConfirmationDialog ref="confirm" />
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import FileDrop from "../components/FileDrop";
import ConfirmationDialog from "@/components/ConfirmationDialogYesNo";
import VueUploadComponent from "vue-upload-component";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import axios from "axios";
import moment from "moment";
import lodash from "lodash";

export default {
  name: "OrgPurchasePublication",
  components: {
    Pagination,
    Notification,
    ConfirmationDialog
  },
  methods: {
    handleInputSelection(items) {},
    validatePurcchaseOrg() {
      if (this.purchaseOrder.OrganizationId > 0) {
        return true;
      } else {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Organization is rquired");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      }
    },
    validateDateOfPayment() {
      if (this.purchaseOrder.DateOfPayment != "") {
        return true;
      } else {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Date of Payment is rquired");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      }
    },
    validatePaymentAmount() {
      if (this.purchaseOrder.Amount > 0) {
        return true;
      } else {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Payment amount is rquired");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      }
    },
    validateNoOfCcopies() {
      let invalidCopy = lodash.filter(this.cart_items, function(o) {
        return o.NoOfCopies == null || o.NoOfCopies == 0 || o.NoOfCopies < 0;
      });
      if (invalidCopy != null && invalidCopy.length > 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid No Of Copies specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateTransactionTypeSelection() {
      let invalidCopy = lodash.filter(this.cart_items, function(o) {
        return o.PurchaseType == null || o.PurchaseType == 0;
      });
      if (invalidCopy != null && invalidCopy.length > 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid PurchaseType specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validatePaidAmount() {
      if (this.purchaseOrder.Amount == null || this.purchaseOrder.Amount == 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid Amount specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateEmptyCart() {
      if (this.cart_items == null || this.cart_items.length == 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Cart is empty");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validatePaymentMadeBy() {
      var nameRegex = /^([a-zA-Z ]){2,30}$/i;
      if (!nameRegex.test(this.purchaseOrder.PaymentMadeBy)) {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Please enter valid name for Payment Made By");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateZohoReferenceNo() {
      var nameRegex = /^([a-zA-Z]){2}-[0-9]{5}$/i;
      if (!nameRegex.test(this.purchaseOrder.ReferenceNo)) {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Please enter valid Zoho Reference No");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    isValidateRowItem(item) {
      if (item.NoOfCopies == null || parseInt(item.NoOfCopies) <= 0) {
        return false;
      } else if (item.PurchaseType <= 0) {
        return false;
      } else if (item.StartDate == "") {
        return false;
      } else if (item.EndDate == "") {
        return false;
      } else {
        return true;
      }
    },
    navReviewPurchase() {
      if (
        this.validatePurcchaseOrg() == true &&
        this.validateNoOfCcopies() == true &&
        this.validateEmptyCart() == true &&
        this.validateTransactionTypeSelection() == true
      ) {
        this.purchaseStep = 3;
      }
    },
    onSearch() {
      this.paging_purchased.page = 1;
      this.getOrganizationPurchaseByPagin();
    },
    getOrganizationPurchaseByPagin() {
      let that = this;
      that.overlay = true;
      console.log(this.paging_purchased);
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order", this.paging_purchased)
          .then(response => {
            this.list = lodash.orderBy(response.data.data, ["id"], ["desc"]);
            this.paging_purchased.count = response.data.count;
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getOrganizationList() {
      console.log(this.paging_purchased);
      this.organizationList = [];
      return new Promise((resolve, reject) => {
        api
          .getAll("organization", this.paging_purchased)
          .then(response => {
            this.organizationList = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAvalaibleApplicationsByPagin() {
      let that = this;
      that.overlay = true;
      console.log(this.paging_avaliiableApplications);
      this.avaliiableApplicationList = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("publications", this.paging_avaliiableApplications)
          .then(response => {
            this.avaliiableApplicationList = response.data.data.map(element => {
              element.StartDate = null;
              element.EndDate = null;
              element.AllowEdit = false;
              element.NoOfCopies = 0;
              return element;
            });
            this.paging_avaliiableApplications.count = response.data.count;
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    OnselectedPurchaseItem(item) {
      if (item.value == true) {
        item.item.AllowEdit = true;
      } else {
        item.item.AllowEdit = false;
      }
    },
    async createPurchaseorder() {
      let that = this;
      if (this.validateDateOfPayment() == false) {
        return;
      }
      if (this.validatePaymentAmount() == false) {
        return;
      }
      if (this.validateNoOfCcopies() == false) {
        return;
      }
      if (this.validatePaidAmount() == false) {
        return;
      }
      if (this.validatePaymentMadeBy() == false) {
        return;
      }
      if (this.validateZohoReferenceNo() == false) {
        return;
      }
      let purchaseReqeust = {
        id: 0,
        Amount: parseInt(that.purchaseOrder.Amount),
        DateOfPayment: that.purchaseOrder.DateOfPayment,
        ReferenceNo: that.purchaseOrder.ReferenceNo,
        PaymentMadeBy: that.purchaseOrder.PaymentMadeBy,
        PaymentConfirmed: that.purchaseOrder.PaymentConfirmed,
        IsCollection: that.purchaseOrder.IsCollection,
        OrganizationId: that.purchaseOrder.OrganizationId,
        PurchaseDetails: []
      };
      if ((that.cart_items != null) & (that.cart_items.length > 0)) {
        purchaseReqeust.PurchaseDetails = that.cart_items.map(e => {
          return {
            id: 0,
            NoOfCopies: e.NoOfCopies,
            StartDate: e.StartDate,
            EndDate: e.EndDate,
            PublicationId: e.id,
            collectionId: 0
          };
        });
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this purchase?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .update("purchase-order", purchaseReqeust)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                that.clear();
                this.purchaseCompleted = true;
                this.notify.type = 1;
                this.notify.message =
                  purchaseReqeust.id === 0
                    ? "successfully saved."
                    : "successfully updated.";
                this.purchaseStep = 1;
                this.getOrganizationPurchaseByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.purchaseCompleted = false;
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onNextPagePurchased(page) {
      this.paging_purchased.page = page;
      this.getOrganizationPurchaseByPagin();
    },
    onNextAvaliiableApplications(page) {
      this.paging_avaliiableApplications.page = page;
      this.getAvalaibleApplicationsByPagin();
    },
    onChangePurchaseType(item) {
      if (item.PurchaseType > 0) {
        item.StartDate = moment()
          .add(1, "day")
          .format("YYYY-MM-DD");
      }

      if (item.PurchaseType == 1) {
        item.EndDate = moment()
          .add(50, "year")
          .format("YYYY-MM-DD");
      }

      if (item.PurchaseType == 2) {
        item.EndDate = moment()
          .add(31, "day")
          .format("YYYY-MM-DD");
      }

      if (item.PurchaseType == 3) {
        item.EndDate = moment()
          .add(91, "day")
          .format("YYYY-MM-DD");
      }

      if (item.PurchaseType == 4) {
        item.EndDate = moment()
          .add(151, "day")
          .format("YYYY-MM-DD");
      }
    },
    addToCart(item) {
      let that = this;
      if (this.isValidateRowItem(item)) {
        let isAlreadyExists = lodash.find(this.cart_items, { id: item.id, PurchaseType: item.PurchaseType });
        debugger;
        if (isAlreadyExists == undefined) {
          this.cart_items.push(Object.assign({}, item));
          this.clearCartItemSelection(item);
        } else {
          this.notify1.type = 4;
          this.notify1.errors = [];
          this.notify1.errors.push("Item has already been added to the cart");
          setTimeout(() => {
            this.notify1.type = 0;
          }, 3000);
        }
      }
    },
    removeFromCart(item) {
      let index = lodash.findIndex(this.cart_items, { id: item.id });
      this.cart_items.splice(index, 1);
    },
    row_invalidClass(item) {
      if (!Number(item.NoOfCopies) > 0 || !Number(item.PurchaseType) > 0) {
        return "errorRow";
      }
    },
    clear() {
      this.purchaseOrder.id = 0;
      this.purchaseOrder.Amount = 0;
      this.purchaseOrder.DateOfPayment = "";
      this.purchaseOrder.ReferenceNo = "";
      this.purchaseOrder.PaymentMadeBy = "";
      this.purchaseOrder.PaymentConfirmed = "";
      this.purchaseOrder.OrganizationId = 0;
      this.purchaseOrder.Description = "";
      this.purchaseOrder.PurchaseDetails.splice(
        0,
        this.purchaseOrder.PurchaseDetails.length
      );
      this.cart_items.forEach(e => {
        e.NoOfCopies = 0;
        e.StartDate = "";
        (e.EndDate = ""), (e.PurchaseType = "");
      });
      this.cart_items.splice(0, this.cart_items.length);
    },
    newPurchase() {
      this.purchaseStep = 2;
      this.purchaseCompleted = false;
    },
    clearCartItemSelection(item) {
      item.NoOfCopies = 0;
      item.PurchaseType = 0;
      item.StartDate = "";
      item.EndDate = "";
    },
    async onCancel(item) {
      console.log(item)
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this record?"
        )
      ) {
           window.location = `/purchaseOrderCancel/${item.id}/${item.OrganizationId}/${item.IsCollection}`; 
      }
    }
  },
  mounted() {
    this.paging_purchased.count = 10;
    this.paging_purchased.page = 1;
    this.paging_purchased.size = 10;
    if (this.$route.params.page != null) {
      this.paging_purchased.page = parseInt(this.$route.params.page);
    }
    this.onSearch();
    this.getOrganizationList();
    this.getAvalaibleApplicationsByPagin();
  },
  data() {
    return {
      purchaseStep: 1,
      purpub_headers: [
        {
          text: "Organization Name",
          align: "start",
          sortable: false,
          value: "OrganizationName"
        },
        {
          text: "Date of Payment",
          align: "start",
          sortable: false,
          value: "DateOfPayment"
        },
        {
          text: "Amount",
          align: "start",
          sortable: false,
          value: "Amount"
        },
        {
          text: "Payment Made By",
          align: "start",
          sortable: false,
          value: "PaymentMadeBy"
        },
        {
          text: "Payment Confirmation",
          align: "start",
          sortable: false,
          value: "PaymentConfirmed"
        },
        {
          text: "Zoho Reference No",
          align: "start",
          sortable: false,
          value: "ReferenceNo"
        },
        {
          text: "Details",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "IsCancel"
        }
      ],
      list: [],
      organizationList: [],
      avaliiableApplicationList: [],
      organizationPurchaseList: [],
      purchasePublication: [{ PurchaseDetails: [] }],
      menu2: false,
      singleSelect: false,
      avaliablePublication_headers: [
        { text: "ISBN", align: "start", value: "ISBN" },
        { text: "Title", value: "Title" },
        { text: "Publisher", value: "PublisherName" },
        { text: "Transaction Type", value: "PurchaseType" },
        { text: "No of Copies", value: "NoOfCopies", width: "7.5%" },
        { text: "Start Date", value: "StartDate" },
        { text: "End Date", value: "EndDate" },
        { text: "Add to Cart", value: "Id" }
      ],
      cart_headers: [
        { text: "ISBN", align: "start", value: "ISBN" },
        { text: "Title", value: "Title" },
        { text: "Transaction Type", value: "PurchaseType", width: "18%" },
        { text: "No of Copies", value: "NoOfCopies", width: "8%" },
        { text: "Start Date", value: "StartDate", width: "10%" },
        { text: "End Date", value: "EndDate", width: "10%" },
        { text: "Action", value: "Id" }
      ],
      cart_items: [],
      reviewPurchase_headers: [
        {
          text: "ISBN",
          align: "start",
          value: "ISBN"
        },
        { text: "Title", value: "Title" },
        { text: "Publisher", value: "PublisherName" },
        { text: "No of Copies", value: "NoOfCopies" },
        { text: "Start Date", value: "StartDate" },
        { text: "End Date", value: "EndDate" }
      ],
      desserts: [
        {
          isbn: "123654987456132",
          title: "Harry Potter",
          publisher: "JK Rowling",
          copies: 24,
          startdate: 4.0,
          enddate: "1%"
        }
      ],
      paging_purchased: { count: 10, page: 1, size: 10, keyword: "", orderColumn: 'Id', isASC: false },
      paging_avaliiableApplications: {
        count: 10,
        page: 1,
        size: 10,
        keyword: ""
      },
      purchaseOrder: {
        id: 0,
        Amount: 0,
        DateOfPayment: "",
        ReferenceNo: "",
        PaymentMadeBy: "",
        PaymentConfirmed: true,
        IsCoreCollection: false,
        OrganizationId: 0,
        PurchaseDetails: []
      },
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      notify1: {
        type: 0,
        message: "",
        errors: []
      },
      notify2: {
        type: 0,
        message: "",
        errors: []
      },
      purchaseCompleted: false,
      purchaseTypeList: [
        {
          text: "Purchase (50 years)",
          value: 1
        },
        {
          text: "Rental 30 days",
          value: 2
        },
        {
          text: "Rental 90 days",
          value: 3
        },
        {
          text: "Rental 150 days",
          value: 4
        },
        {
          text: "Other ",
          value: 5
        }
      ],
      itemRowValidationMessage: "",
      overlay: false,
    };
  },
  computed: {
    comNoOfPublications: function() {
      if (this.cart_items != null && this.cart_items.length > 0) {
        return this.cart_items.length;
      } else {
        return 0;
      }
    },
    comNumberOfCcopies: function() {
      if (this.cart_items != null && this.cart_items.length > 0) {
        let sum = this.cart_items.reduce((t, obj) => {
          return parseInt(t) + parseInt(obj.NoOfCopies);
        }, 0);

        return sum;
      } else {
        return 0;
      }
    },
    comMinStartDate: function() {
      if (this.cart_items != null && this.cart_items.length > 0) {
        let moments = this.cart_items.map(d => {
          let momentDate = moment(d.StartDate);
          if (momentDate.isValid()) {
            return momentDate;
          } else {
            return null;
          }
        });
        var min = moment.min(moments);
        return min != null && min.isValid() ? min.format("MM/DD/YYYY") : "";
      } else {
        return "";
      }
    },
    comMaxEndDate: function() {
      if (this.cart_items != null && this.cart_items.length > 0) {
        let moments = this.cart_items.map(d => {
          let momentDate = moment(d.EndDate);
          if (momentDate.isValid()) {
            return momentDate;
          } else {
            return null;
          }
        });
        var min = moment.max(moments);
        return min != null && min.isValid() ? min.format("MM/DD/YYYY") : "";
      } else {
        return "";
      }
    },
    comOrganizationName: function() {
      let selectedOrg = lodash.filter(this.organizationList, {
        id: this.purchaseOrder.OrganizationId
      });
      if (selectedOrg != null && selectedOrg.length > 0) {
        return selectedOrg[0].Name;
      } else {
        return "not found";
      }
    }
  },
  filters: {
    DateFromatDDMMYYY: function(value) {
      if (value == null || value == "") {
        return "MM-DD-YYYY";
      }
      return moment(value).format("MM-DD-YYYY");
    }
  }
};
</script>
<style scoped>
.action-area {
  padding-top: 5px;
}
.container-file {
  border: 2px dashed lightslategrey;
  height: 80px;
  background: rgb(238, 250, 255);
  text-align: center;
}
.fileText {
  margin: auto;
}
.file-wrapper {
  text-align: center;
  height: 80px;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: rgb(238, 250, 255);
}
.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 300px;
  height: 200px;
}
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}

.errorRow {
  background-color: orange;
}
</style>



// WEBPACK FOOTER //
// src/views/Purchase.vue